import {
    API_REFRESH_PROFILE,
    UPDATE_TYPE,
    API_GET_NAME,
    API_GET_DOMAIN,
    API_UPDATE_NAME,
    API_GET_NAME_UNHIDDEN,
    API_GET_RESUME_INFO,
    API_LEVEL_PROFILE,
    API_CHANGE_SEARCHABLE,
    API_UPDATE_DOMAIN,
    API_UPDATE_RESUME_SETTING_OPTION,
    API_GET_RESUME_ATTACHMENT_LIST,
    API_GET_OPEN_TO_WORK
} from './constants'

const BASE_PATH = process.env.NEXT_PUBLIC_MS_BASE_PATH
const REFRESH_PROFILE_API = `${BASE_PATH}${API_REFRESH_PROFILE}`
const OPEN_TO_WORK_API = `${BASE_PATH}${API_GET_OPEN_TO_WORK}`
const GET_RESUME_INFO_API = `${BASE_PATH}${API_GET_RESUME_INFO}?date=${Date.now()}`
const GET_LEVEL_PROFILE_API = `${BASE_PATH}${API_LEVEL_PROFILE}`
const GET_NAME_API = `${BASE_PATH}${API_GET_NAME}`
const GET_NAME_UNHIDDEN_API = `${BASE_PATH}${API_GET_NAME_UNHIDDEN}`
const UPDATE_DOMAIN_API = `${BASE_PATH}${API_UPDATE_DOMAIN}`
const GET_DOMAIN_API = `${BASE_PATH}${API_GET_DOMAIN}`
const UPDATE_NAME_API = `${BASE_PATH}${API_UPDATE_NAME}`
const CHANGE_SEARCHABLE_API = `${BASE_PATH}${API_CHANGE_SEARCHABLE}`
const UPDATE_RESUME_SETTING_OPTION_API = `${BASE_PATH}${API_UPDATE_RESUME_SETTING_OPTION}`
const GET_RESUME_ATTACHMENT_LIST_API = `${BASE_PATH}${API_GET_RESUME_ATTACHMENT_LIST}?date=${Date.now()}`

export const apiGetUnHiddenCompany = async (token: string, langCode: string, companyName: string = '') => {
    try {
        const savedJobResponse = await fetch(GET_NAME_UNHIDDEN_API, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Accept-Language': langCode
            },
            body: JSON.stringify({
                companyName: companyName
            })
        })
        return await savedJobResponse.json()
    } catch (e) {
        console.log('apiGetUnHiddenCompany ', e)
        return []
    }
}

export const apiGetUserHiddenDomains = async (token: string) => {
    try {
        const response = await fetch(GET_DOMAIN_API, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })

        return await response.json()
    } catch (e) {
        console.log('apiGetUserHiddenDomains ', e)
        return []
    }
}

export const apiGetUserHiddenCompanyName = async (token: string) => {
    try {
        const response = await fetch(GET_NAME_API, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return await response.json()
    } catch (e) {
        console.log('apiGetUserHiddenCompanyName ', e)
        return []
    }
}

export const apiUpdateUserHiddenDomain = async (
    accessToken: string,
    langCode: string,
    data = {
        domain: '',
        type: UPDATE_TYPE.ADD
    }
) => {
    try {
        const response = await fetch(UPDATE_DOMAIN_API, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                'Accept-Language': langCode
            },
            body: JSON.stringify(data)
        })
        return await response.json()
    } catch (e) {
        console.log('apiUpdateUserHiddenDomain ', e)
        return []
    }
}

export const apiUpdateUserHiddenCompanyName = async (
    accessToken: string,
    langCode: string,
    data = {
        taxCode: '',
        type: UPDATE_TYPE.ADD
    }
) => {
    try {
        const response = await fetch(UPDATE_NAME_API, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                'Accept-Language': langCode
            },
            body: JSON.stringify(data)
        })
        return await response.json()
    } catch (e) {
        console.log('apiUpdateUserHiddenCompanyName ', e)
        return []
    }
}

export const apiGetResumeLevel = async (token) => {
    try {
        const response = await fetch(GET_LEVEL_PROFILE_API, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return await response.json()
    } catch (e) {
        console.log('apiGetResumeLevel ', e)
        return []
    }
}

export const apiChangeSearchable = async (
    accessToken: string,
    langCode: string,
    data: any = {
        resumeId: -1,
        searchAble: false
    }
) => {
    try {
        const changeSearchableResponse = await fetch(CHANGE_SEARCHABLE_API, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
                'Accept-Language': langCode
            },
            body: JSON.stringify(data)
        })
        return await changeSearchableResponse.json()
    } catch (e) {
        console.log('apiChangeSearchable ', e)
        return []
    }
}

export const apiGetResumeInfo = async (accessToken: string) => {
    try {
        const response = await fetch(GET_RESUME_INFO_API, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: '0',
                Authorization: `Bearer ${accessToken}`
            }
        })
        return await response.json()
    } catch (e) {
        console.log('apiGetResumeInfo ', e)
        return {}
    }
}

export const apiGetOpenToWork = async (accessToken: string) => {
    try {
        const response = await fetch(OPEN_TO_WORK_API, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        })
        return await response.json()
    } catch (ex) {
        console.log('apiGetOpenToWork ', ex)
        return null
    }
}

export const apiGetRefresh = async (token) => {
    try {
        const response = await fetch(REFRESH_PROFILE_API, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        })
        return await response.json()
    } catch (e) {
        console.log('apiGetRefresh ', e)
        return []
    }
}

export const apiMakeRefresh = async (
    accessToken: string,
    language: string,
    data = {
        type: -1,
        status: 0
    }
) => {
    try {
        const makeRefreshResponse = await fetch(REFRESH_PROFILE_API, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
                'Accept-Language': language
            },
            body: JSON.stringify(data)
        })

        return await makeRefreshResponse.json()
    } catch (e) {
        console.log('apiMakeRefresh ', e)
        return []
    }
}

export const apiUpdateResumeSetting = async (
    accessToken: string,
    language: string,
    data: {
        chooseCV?: string
        chooseRefreshType?: number
        resumeId?: number
    } = {
        chooseCV: '',
        chooseRefreshType: 0,
        resumeId: -1
    }
) => {
    try {
        const makeRefreshResponse = await fetch(UPDATE_RESUME_SETTING_OPTION_API, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
                'Accept-Language': language
            },
            body: JSON.stringify(data)
        })

        return await makeRefreshResponse.json()
    } catch (e) {
        console.log('apiUpdateResumeSetting ', e)
        return []
    }
}

export const apiAttachmentList = async (accessToken: string) => {
    try {
        const response = await fetch(GET_RESUME_ATTACHMENT_LIST_API, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: '0',
                Authorization: `Bearer ${accessToken}`
            }
        })
        return await response.json()
    } catch (e) {
        console.log('apiAttachmentList ', e)
        return []
    }
}
